import login from "./login"
import logout from "./logout"

export { login, logout }

const auth = { login, logout }

export default auth
